// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sBFMa","colBig":"styles_colBig__17av5","colSmall":"styles_colSmall__3pKIw"};